/**
 * RefOptions service exports
 * Uses centralized ServiceFactory for dependency injection
 */

import { ServiceFactory } from "../ServiceFactory";

// Export the abstraction, not the implementation
export const refOptionsService = ServiceFactory.getRefOptionsService();

// Export implementations and types for consumers
export type { IRefOptionsService } from "./IRefOptionsService";
export { RefOptionsService } from "./RefOptionsService";
export { RefOptionsServiceMock } from "./RefOptionsServiceMock";
